import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { finalize, take, takeWhile } from 'rxjs/operators';
import { FichaCadastro } from '../../ficha-veiculo/ficha-cadastro/ficha-cadastro';
import { TipoResidenciaService } from '../../services/tipo-residencia/tipo-residencia.service';
import moment from 'moment';

@Component({
  selector: 'app-residencia',
  templateUrl: './residencia.component.html',
  styleUrls: ['./residencia.component.scss'],
})
export class ResidenciaComponent implements OnInit, OnDestroy {
  @Input() fichaCadastro: FichaCadastro;

  @Output() residenciaFormValidEmit = new EventEmitter();
  @Output() residenciaFormEmit = new EventEmitter();

  residenciaForm: FormGroup;
  isAlive = true;

  listaCondicoesResidencia: any[] = [];

  isLoadingCondicoesResidencia = false;
  showCondicaoResidenciaOutro = false;
  condicaoResidenciaOutroTouched = false;

  constructor(
    private fb: FormBuilder,
    private tipoResidencia: TipoResidenciaService
  ) {}

  ngOnInit() {
    this.initForm();
    this.initObservables();
    this.buscarCondicoesResidencia();
    this.patchValue();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  patchValue() {
    if (this.fichaCadastro._client && this.fichaCadastro._client.enderecos) {
      this.residenciaForm.patchValue({
        condicaoResidencia: Number(
          this.fichaCadastro._client.enderecos.condicaoResidencia
        ),
        tempoResidencia: new Date(
          Number(this.fichaCadastro._client.enderecos.tempoResidencia)
        ),
      });
    }
  }

  initForm() {
    this.residenciaForm = this.fb.group({
      condicaoResidencia: [ {value: '', disabled: this.isLoadingCondicoesResidencia} , [Validators.required]],
      condicaoResidenciaOutro: ['', [Validators.required]],
      tempoResidencia: [
        '',
        [Validators.required, this.datePosteriorValidator()],
      ],
    });
  }

  private datePosteriorValidator(): ValidatorFn {
    return (control: AbstractControl): Validators | null => {
      const value: string = control.value;
      if (!value) {
        return null;
      }
      const dateAux = moment(`01${value}`, 'DDMMYYYY');
      if (dateAux && dateAux.isAfter(moment())) {
        const message =
          'Tempo de Residência não pode ser superior a data atual';
        return { message };
      }
      return null;
    };
  }

  initObservables() {
    this.residenciaForm.valueChanges
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(() => {
        this.residenciaFormValidEmit.next(this.isValid);
        this.residenciaFormEmit.next(this.residenciaForm.getRawValue());
      });
  }

  private buscarCondicoesResidencia() {
    this.isLoadingCondicoesResidencia = true;
    this.onCondicoesResidenciaChange();
    this.tipoResidencia
      .getTipoResidencia()
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingCondicoesResidencia = false;
          this.onCondicoesResidenciaChange();
        })
      )
      .subscribe(
        (response) => (this.listaCondicoesResidencia = response.tipos)
      );
  }

  onChangeCondicoesResidencia() {
    this.condicaoResidenciaOutro.reset();

    this.showCondicaoResidenciaOutro = this.hasOutraCondicao;
  }

  onBlurCondicaoResidenciaOutro() {
    if (
      !this.condicaoResidenciaOutro.value &&
      this.showCondicaoResidenciaOutro
    ) {
      this.condicaoResidenciaOutroTouched = true;
    }
  }

  get condicaoResidencia(): AbstractControl {
    return this.residenciaForm.get('condicaoResidencia');
  }

  get condicaoResidenciaOutro(): AbstractControl {
    return this.residenciaForm.get('condicaoResidenciaOutro');
  }

  get tempoResidencia(): AbstractControl {
    return this.residenciaForm.get('tempoResidencia');
  }

  get isValid() {
    if (this.hasOutraCondicao) {
      return (
        this.condicaoResidencia.valid &&
        this.condicaoResidenciaOutro.value !== '' &&
        this.condicaoResidenciaOutro.value !== null &&
        this.tempoResidencia.valid
      );
    }

    return (
      this.condicaoResidencia.valid &&
      this.condicaoResidencia.value !== null &&
      this.condicaoResidencia.value !== '' &&
      !isNaN(this.condicaoResidencia.value) &&
      this.tempoResidencia.valid
    );
  }

  get hasOutraCondicao() {
    return this.listaCondicoesResidencia.some((item) => {
      return item.id === this.condicaoResidencia.value && item.edicao === 'S';
    });
  }

  onCondicoesResidenciaChange() {
    if (this.isLoadingCondicoesResidencia) {
      this.residenciaForm.get('condicaoResidencia')?.disable();
    }
    else {
      this.residenciaForm.get('condicaoResidencia')?.enable();
    }
  }
}
